import { render, staticRenderFns } from "./flowDirectionList.vue?vue&type=template&id=0940310a&scoped=true"
import script from "./flowDirectionList.vue?vue&type=script&lang=js"
export * from "./flowDirectionList.vue?vue&type=script&lang=js"
import style0 from "./flowDirectionList.vue?vue&type=style&index=0&id=0940310a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940310a",
  null
  
)

export default component.exports